<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const isRTL = computed(() => store.state.isRTL);
const sidebarMinimize = () => store.commit("sidebarMinimize");

const minimizeSidebar = () => {
  if (window.innerWidth < 1200) {
    sidebarMinimize();
  }
};

defineProps({
  to: {
    type: [Object, String],
    required: true,
  },
  navText: {
    type: String,
    required: true,
  },
  collapsed: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <router-link
    v-tooltip="collapsed ? navText : ''"
    :to="to"
    class="nav-link"
    :class="{ 'is-collapsed': collapsed }"
    @click="minimizeSidebar"
  >
    <div
      class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
    >
      <slot name="icon"></slot>
    </div>
    <span v-if="!collapsed" class="nav-link-text" :class="isRTL ? ' me-2' : 'ms-2'">{{
      navText
    }}</span>
  </router-link>
</template>
